export const mergeItems = ({ items = [], item }) => {
  if (items.length === 0) {
    return [item];
  }

  const sameItemIndex = items.findIndex(
    (i) => i.id === item.id &&
      i.selection.size.id === item.selection.size.id &&
      modifiersAreSame(i.selection.modifiers, item.selection.modifiers),
  );

  if (sameItemIndex === -1) {
    return [...items, item];
  }

  const mergedItem = items[sameItemIndex];

  return [
    ...items.filter((_, index) => index !== sameItemIndex),
    {
      ...mergedItem,
      qty: mergedItem.selection.qty + item.selection.qty,

      selection: {
        ...mergedItem.selection,
        qty: mergedItem.selection.qty + item.selection.qty,
      },
    },
  ];
};

export function sortItems(items) {
  return items.sort((a, b) => a.id - b.id);
}

function modifiersAreSame(firstModifiers, secondModifiers) {
  const firstModifiersValue = Object.values(firstModifiers);
  const secondModifiersValue = Object.values(secondModifiers);
  if (firstModifiersValue.length !== secondModifiersValue.length) {
    return false;
  }
  return firstModifiersValue.every((fm) => secondModifiersValue.some(
    (sm) => sm.id === fm.id && sm.qty === fm.qty,
  ));
}

export const pluralize = (word, qty) => {
  if (qty < 2) {
    return word;
  }
  if (word.toLowerCase() === 'person') {
    return 'people';
  }
  if (word.endsWith('y') && !word.endsWith('ay') && !word.endsWith('ey') && !word.endsWith('iy') && !word.endsWith('oy') && !word.endsWith('uy')) {
    return `${word.slice(0, -1)}ies`;
  }
  let needES = false;
  ['s', 'ss', 'sh', 'ch', 'x', 'z'].forEach((char) => {
    if (word.endsWith(char)) needES = true;
  });
  return `${word}${needES ? 'es' : 's'}`;
};
